// extracted by mini-css-extract-plugin
export var padding = "pagePadding-module--padding--D8bNu";